<template>
    <div class="c-card" :style="rootStyle">
        <slot />
    </div>
</template>

<script>
import { C_PANEL } from './tokens';

export default {
    name: 'CCard',
    props: {
        padded: { type: Boolean, default: true },
        // Optional extra styles applied on top of the base card. Mirrors the
        // prototype's `style={{ ... }}` overrides used per-screen for
        // padding tweaks and inverted (dark) cards.
        extraStyle: { type: Object, default: () => ({}) },
    },
    computed: {
        rootStyle() {
            return {
                background: C_PANEL,
                borderRadius: '24px',
                boxShadow:
                    '0 1px 0 rgba(0,0,0,0.04), 0 24px 48px -20px rgba(60,40,20,0.12)',
                padding: this.padded ? '36px' : 0,
                ...this.extraStyle,
            };
        },
    },
};
</script>
